import { jsx as _jsx } from "react/jsx-runtime";
import { EventEmitter } from 'events';
import { t } from '../../../../modules/infra/i18n';
export var RebookAppointmentButton = function (_a) {
    var appointment = _a.appointment;
    var handleClick = function () {
        EventEmitter.prototype.emit('close-appointment-modal', 'details');
        EventEmitter.prototype.emit('rebook-appointment', { appointment: appointment });
        EventEmitter.prototype.emit('open-appointment-modal', 'new');
    };
    return (_jsx("div", { className: "u-inline-block u-1/1-medium-and-down", children: _jsx("button", { type: "button", onClick: handleClick, className: "c-btn large-and-up-ph- u-mr--", children: _jsx("span", { className: "c-btn__text", children: t('appointment:actions.rebook') }) }) }));
};
